export default {
    faqsButtonClicked: 'faqs-clicked',
    scrollToFaqs: 'scroll-to-faqs'
}